import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        En Mjasojedovskaja estas jam trankvile, <br/>
        La civitanoj digne paŝas, orobrile, <br/>
        Sonas ĉiam konata odesa ĵargon’, <br/>
        Kaj konstante troviĝas iu aŭdaca person’. <br/>
        Sed mi neniam vidis ŝarĝoĉaron, <br/>
        Ĉar ilia tempo pasis antaǔ multaj jaroj. <br/>
        Mi naskiĝis en la temp’ de rok-n-rol’, <br/>
        Sed odesajn kantojn kantas mi kun bonvol’.
      </p>

      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf:</span> <br/>
        Mi promenas laŭ bulvardo ridetante al Djuk’, <br/>
        Mi ĝentile ne rigardas al li ekde dua luk’. <br/>
        Mi salutas lin, kaj li diras –jes! – <br/>
        Ke mi fieras loĝi kaj naskiĝi en Odes’.
      </p>

      <p class="poem-block mb-3">
        Laŭ Moldavanka-stratoj piedpaŝas mi, <br/>
        Ĉiu korteto ŝajnas proksima amik’. <br/>
        Ne tro pure, sed tie mia malnova dom’, <br/>
        Kiu baldaǔ ruiniĝos, falos, kaj poste do <br/>
        Oni lasos min loĝi en la fora Poskot’, <br/>
        Kie ĉiam kuŝas abunda nigra kot’; <br/>
        En tiu gaja distrikto abundas homoj kaj muŝoj, <br/>
        Kaj ĉiu havas sian propran necesejon kun duŝo.
      </p>
      
      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf.</span>
      </p>

      <p class="poem-block mb-3">
        Ho, kiuj homoj, kia bela mar’! <br/>
        Kia sekura estas nia ŝipar’! <br/>
        Se vi estas artisto, certe do aferisto, <br/>
        Kaj se vi muzikisto, certe do spekulisto. <br/>
        Sub suda suno floras mia urb’, <br/>
        Ĝi ridas, ŝercas kaj prosperas sen dub’. <br/>
        Mi plezure aǔskultas prononcon kun erar’: <br/>
        «En Odeso plej gravas la ŝercoj kaj la mar’».
      </p>

    </div>
    `
  )
}

const itemName = {
  esp: 'Odesa kanto de Gankeviĉ'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['ZCDp82K5gqs'],
    itemTranslator: `
      Teksto kaj muziko: I. Gankeviĉ, <br/>
      ${translator.esp}
    `
  }
}

export default item;